export enum DateQueryDateTypeApiEnum {
    PUBLISHED = 'PUBLISHED',
    INDEXED = 'INDEXED',
    CREATED = 'CREATED',
    EDITED = 'EDITED'
}
